import {
  serviceRecuperaFiliais,
} from './Service/service';

export const mockUnidadesAtendimento = async () => {

    const filiais = await serviceRecuperaFiliais();
    if (filiais)
        return filiais.map(t => { return { id: t.cdFilial, nome: t.nmFilial, cCusto: t.cdCCusto } })
    else
        return []
}

export function mockSociedadesUBC() {
    return ['Abramus', 'Amar', 'Assim', 'Sbacem', 'Sicam', 'Socinpro', 'Anacim', 'Abrac', 'Atida', 'Sadembra',];
}

export function mockComoConheceuUBC() {
    return [
        { id: 1, nome: 'INTERNET' },
        { id: 2, nome: 'FUNCIONÁRIO' },
        { id: 3, nome: 'EDITORA/GRAVADORA' },
        { id: 4, nome: 'EVENTO' },
        { id: 5, nome: 'OUTRO' },
    ];
}

export function mockGeneros() {
    return [
        { id: 'M', nome: 'Homem Cis' },
        { id: 'F', nome: 'Mulher Cis' },
        { id: 'T', nome: 'Homem Trans' },
        { id: 'Y', nome: 'Mulher Trans' },
        { id: 'N', nome: 'Não-binário' },
        { id: 'O', nome: 'Outro' },
        { id: 'I', nome: 'Prefiro não informar' },
    ];
}

export function mockEstadoCivil() {
    return [
        { id: 'S', nome: 'Solteiro' },
        { id: 'C', nome: 'Casado' },
        { id: 'D', nome: 'Divorciado' },
        { id: 'V', nome: 'Viúvo' },
    ];
}

export function mockParticipacoes() {
    return [
        { id: 1, nome: 'Rádio' },
        { id: 2, nome: 'Show' },
        { id: 3, nome: 'TV' },
        { id: 4, nome: 'Festivais' },
        { id: 5, nome: 'Festas e Eventos' },
        { id: 6, nome: 'Streaming' },
        { id: 7, nome: 'YouTube' },
        { id: 8, nome: 'Cinema' },
    ];
}

export function mockEstados() {
    return [
        {
            "id": "AM",
            "nome": "AMAZONAS"
        },
        {
            "id": "MA",
            "nome": "MARANHÃO"
        },
        {
            "id": "RJ",
            "nome": "RIO DE JANEIRO"
        },
        {
            "id": "SP",
            "nome": "SÃO PAULO"
        },
        {
            "id": "MG",
            "nome": "MINAS GERAIS"
        },
        {
            "id": "BA",
            "nome": "BAHIA"
        },
        {
            "id": "PE",
            "nome": "PERNAMBUCO"
        },
        {
            "id": "AL",
            "nome": "ALAGOAS"
        },
        {
            "id": "ES",
            "nome": "ESPIRITO SANTO"
        },
        {
            "id": "RS",
            "nome": "RIO GRANDE DO SUL"
        },
        {
            "id": "RN",
            "nome": "RIO GRANDE DO NORTE"
        },
        {
            "id": "MT",
            "nome": "MATO GROSSO"
        },
        {
            "id": "MS",
            "nome": "MATO GROSSO DO SUL"
        },
        {
            "id": "AC",
            "nome": "ACRE"
        },
        {
            "id": "RR",
            "nome": "RORAIMA"
        },
        {
            "id": "RO",
            "nome": "RONDONIA"
        },
        {
            "id": "SE",
            "nome": "SERGIPE"
        },
        {
            "id": "PB",
            "nome": "PARAIBA"
        },
        {
            "id": "PI",
            "nome": "PIAUI"
        },
        {
            "id": "PA",
            "nome": "PARA"
        },
        {
            "id": "TO",
            "nome": "TOCANTINS"
        },
        {
            "id": "SC",
            "nome": "SANTA CATARINA"
        },
        {
            "id": "PR",
            "nome": "PARANA"
        },
        {
            "id": "DF",
            "nome": "DISTRITO FEDERAL"
        },
        {
            "id": "GO",
            "nome": "GOIAS"
        },
        {
            "id": "AP",
            "nome": "AMAPA"
        },
        {
            "id": "CE",
            "nome": "CEARA"
        },
        {
            "id": "OE",
            "nome": "OUTROS ESTADOS"
        }
    ];
}

export function mockNacionalidade() {
    return [
        { id: 76, nome: 'BRASIL' },
        { id: 4, nome: 'AFEGANISTAO' },
        { id: 710, nome: 'AFRICA DO SUL' },
        { id: 8, nome: 'ALBANIA' },
        { id: 276, nome: 'ALEMANHA' },
        { id: 20, nome: 'ANDORRA' },
        { id: 24, nome: 'ANGOLA' },
        { id: 28, nome: 'ANTIGUA E BARBUDA' },
        { id: 682, nome: 'ARABIA SAUDITA' },
        { id: 32, nome: 'ARGENTINA' },
        { id: 12, nome: 'ARGERIA' },
        { id: 51, nome: 'ARMENIA' },
        { id: 533, nome: 'ARUBA' },
        { id: 36, nome: 'AUSTRALIA' },
        { id: 40, nome: 'AUSTRIA' },
        { id: 31, nome: 'AZERBAIJAO' },
        { id: 44, nome: 'BAHAMAS' },
        { id: 48, nome: 'BAHREIN' },
        { id: 50, nome: 'BANGLADESH' },
        { id: 52, nome: 'BARBADOS' },
        { id: 56, nome: 'BELGICA' },
        { id: 84, nome: 'BELIZE' },
        { id: 204, nome: 'BENIN' },
        { id: 60, nome: 'BERMUDA' },
        { id: 112, nome: 'BIELORRUSIA' },
        { id: 68, nome: 'BOLIVIA' },
        { id: 70, nome: 'BOSNIA E HERZEGOVINA' },
        { id: 72, nome: 'BOTSWANA' },
        { id: 96, nome: 'BRUNEI' },
        { id: 100, nome: 'BULGARIA' },
        { id: 854, nome: 'BURKINA FASO' },
        { id: 108, nome: 'BURUNDI' },
        { id: 64, nome: 'BUTAO' },
        { id: 132, nome: 'CABO VERDE' },
        { id: 120, nome: 'CAMAROES' },
        { id: 116, nome: 'CAMBOJA' },
        { id: 124, nome: 'CANADA' },
        { id: 634, nome: 'CATAR' },
        { id: 398, nome: 'CAZAQUISTAO' },
        { id: 148, nome: 'CHADE' },
        { id: 152, nome: 'CHILE' },
        { id: 156, nome: 'CHINA' },
        { id: 196, nome: 'CHIPRE' },
        { id: 170, nome: 'COLOMBIA' },
        { id: 174, nome: 'COMOROS' },
        { id: 178, nome: 'CONGO' },
        { id: 408, nome: 'COREIA DO NORTE' },
        { id: 410, nome: 'COREIA DO SUL' },
        { id: 384, nome: 'COSTA DO MARFIM' },
        { id: 188, nome: 'COSTA RICA' },
        { id: 191, nome: 'CROACIA' },
        { id: 192, nome: 'CUBA' },
        { id: 208, nome: 'DINAMARCA' },
        { id: 262, nome: 'DJIBOUTI' },
        { id: 212, nome: 'DOMINICA' },
        { id: 818, nome: 'EGITO' },
        { id: 222, nome: 'EL SALVADOR' },
        { id: 784, nome: 'EMIRADOS ARABES UNIDOS' },
        { id: 218, nome: 'EQUADOR' },
        { id: 232, nome: 'ERITREA' },
        { id: 703, nome: 'ESLOVAQUIA' },
        { id: 705, nome: 'ESLOVENIA' },
        { id: 724, nome: 'ESPANHA' },
        { id: 840, nome: 'ESTADOS UNIDOS' },
        { id: 233, nome: 'ESTONIA' },
        { id: 231, nome: 'ETIOPIA' },
        { id: 242, nome: 'FIJI' },
        { id: 608, nome: 'FILIPINAS' },
        { id: 246, nome: 'FINLANDIA' },
        { id: 250, nome: 'FRANCA' },
        { id: 266, nome: 'GABAO' },
        { id: 270, nome: 'GAMBIA' },
        { id: 288, nome: 'GANA' },
        { id: 268, nome: 'GEORGIA' },
        { id: 826, nome: 'GRA-BRETANHA' },
        { id: 308, nome: 'GRANADA' },
        { id: 300, nome: 'GRECIA' },
        { id: 312, nome: 'GUADALUPE' },
        { id: 320, nome: 'GUATEMALA' },
        { id: 328, nome: 'GUIANA' },
        { id: 324, nome: 'GUINE' },
        { id: 226, nome: 'GUINE EQUATORIANA' },
        { id: 624, nome: 'GUINE-BISSAU' },
        { id: 332, nome: 'HAITI' },
        { id: 528, nome: 'HOLANDA' },
        { id: 340, nome: 'HONDURAS' },
        { id: 344, nome: 'HONG KONG' },
        { id: 348, nome: 'HUNGRIA' },
        { id: 887, nome: 'IEMEN' },
        { id: 239, nome: 'ILHAS GEORGIA DO SUL E SANDWICH DO SUL' },
        { id: 584, nome: 'ILHAS MARSHALL' },
        { id: 90, nome: 'ILHAS SALOMAO' },
        { id: 796, nome: 'ILHAS TURCAS E CAICOS' },
        { id: 356, nome: 'INDIA' },
        { id: 360, nome: 'INDONESIA' },
        { id: 364, nome: 'IRAN' },
        { id: 368, nome: 'IRAQUE' },
        { id: 372, nome: 'IRLANDA' },
        { id: 352, nome: 'ISLANDIA' },
        { id: 376, nome: 'ISRAEL' },
        { id: 380, nome: 'ITALIA' },
        { id: 388, nome: 'JAMAICA' },
        { id: 392, nome: 'JAPAO' },
        { id: 400, nome: 'JORDANIA' },
        { id: 296, nome: 'KIRIBATI' },
        { id: 414, nome: 'KUWAIT' },
        { id: 418, nome: 'LAOS' },
        { id: 426, nome: 'LESOTO' },
        { id: 428, nome: 'LETONIA' },
        { id: 422, nome: 'LIBANO' },
        { id: 430, nome: 'LIBERIA' },
        { id: 434, nome: 'LIBIA' },
        { id: 438, nome: 'LIECHTENSTEIN' },
        { id: 440, nome: 'LITUANIA' },
        { id: 442, nome: 'LUXEMBURGO' },
        { id: 446, nome: 'MACAO' },
        { id: 807, nome: 'MACEDONIA' },
        { id: 450, nome: 'MADAGASCAR' },
        { id: 458, nome: 'MALASIA' },
        { id: 454, nome: 'MALAWI' },
        { id: 462, nome: 'MALDIVAS' },
        { id: 466, nome: 'MALI' },
        { id: 470, nome: 'MALTA' },
        { id: 504, nome: 'MARROCOS' },
        { id: 480, nome: 'MAURICIA' },
        { id: 478, nome: 'MAURITANIA' },
        { id: 484, nome: 'MEXICO' },
        { id: 104, nome: 'MIAMAR' },
        { id: 583, nome: 'MICRONESIA' },
        { id: 508, nome: 'MOCAMBIQUE' },
        { id: 498, nome: 'MOLDAVIA' },
        { id: 492, nome: 'MONACO' },
        { id: 496, nome: 'MONGOLIA' },
        { id: 499, nome: 'MONTENEGRO' },
        { id: 516, nome: 'NAMIBIA' },
        { id: 520, nome: 'NAURU' },
        { id: 524, nome: 'NEPAL' },
        { id: 558, nome: 'NICARAGUA' },
        { id: 562, nome: 'NIGER' },
        { id: 566, nome: 'NIGERIA' },
        { id: 578, nome: 'NORUEGA' },
        { id: 540, nome: 'NOVA CALEDONIA' },
        { id: 554, nome: 'NOVA ZELANDIA' },
        { id: 512, nome: 'OMAN' },
        { id: 585, nome: 'PALAU' },
        { id: 591, nome: 'PANAMA' },
        { id: 598, nome: 'PAPUA-NOVA GUINE' },
        { id: 586, nome: 'PAQUISTAO' },
        { id: 600, nome: 'PARAGUAI' },
        { id: 604, nome: 'PERU' },
        { id: 258, nome: 'POLINESIA FRANCESA' },
        { id: 616, nome: 'POLONIA' },
        { id: 630, nome: 'PORTO RICO' },
        { id: 620, nome: 'PORTUGAL' },
        { id: 404, nome: 'QUENIA' },
        { id: 417, nome: 'QUIRGUISTAO' },
        { id: 140, nome: 'REPUBLICA CENTRO-AFRICANA' },
        { id: 203, nome: 'REPUBLICA CHECA' },
        { id: 280, nome: 'REPUBLICA DEMOCRATICA DA ALEMANHA' },
        { id: 180, nome: 'REPUBLICA DEMOCRATICA DO CONGO' },
        { id: 214, nome: 'REPUBLICA DOMINICANA' },
        { id: 642, nome: 'ROMENIA' },
        { id: 646, nome: 'RUANDA' },
        { id: 643, nome: 'RUSSIA' },
        { id: 732, nome: 'SAARA OCIDENTAL' },
        { id: 882, nome: 'SAMOA' },
        { id: 674, nome: 'SAN MARINO' },
        { id: 662, nome: 'SANTA LUCIA' },
        { id: 659, nome: 'SAO CRISTOVAO E NEVES' },
        { id: 678, nome: 'SAO TOME E PRINCIPE' },
        { id: 670, nome: 'SAO VICENTE E GRANADINAS' },
        { id: 686, nome: 'SENEGAL' },
        { id: 694, nome: 'SERRA LEOA' },
        { id: 688, nome: 'SERVIA' },
        { id: 891, nome: 'SERVIA E MONTENEGRO' },
        { id: 690, nome: 'SEYCHELES' },
        { id: 702, nome: 'SINGAPURA' },
        { id: 760, nome: 'SIRIA' },
        { id: 706, nome: 'SOMALIA' },
        { id: 144, nome: 'SRI LANKA' },
        { id: 748, nome: 'SUAZILANDIA' },
        { id: 736, nome: 'SUDAO' },
        { id: 729, nome: 'SUDAO' },
        { id: 728, nome: 'SUDAO DO SUL' },
        { id: 752, nome: 'SUECIA' },
        { id: 756, nome: 'SUICA' },
        { id: 740, nome: 'SURINAME' },
        { id: 764, nome: 'TAILANDIA' },
        { id: 158, nome: 'TAIWAN' },
        { id: 762, nome: 'TAJIQUISTAO' },
        { id: 834, nome: 'TANZANIA' },
        { id: 626, nome: 'TIMOR-LESTE' },
        { id: 768, nome: 'TOGO' },
        { id: 776, nome: 'TONGA' },
        { id: 780, nome: 'TRINIDAD E TOBAGO' },
        { id: 788, nome: 'TUNISIA' },
        { id: 795, nome: 'TURQUEMENISTAO' },
        { id: 792, nome: 'TURQUIA' },
        { id: 798, nome: 'TUVALU' },
        { id: 804, nome: 'UCRANIA' },
        { id: 800, nome: 'UGANDA' },
        { id: 858, nome: 'URUGUAI' },
        { id: 860, nome: 'UZBEQUISTAO' },
        { id: 548, nome: 'VANUATU' },
        { id: 336, nome: 'VATICANO' },
        { id: 862, nome: 'VENEZUELA' },
        { id: 704, nome: 'VIETNAM' },
        { id: 894, nome: 'ZAMBIA' },
        { id: 716, nome: 'ZIMBABUE' },
    ];
}